import UniversalCookie from "universal-cookie";

class MyCookie {
  constructor() {
    this.universalCookie = new UniversalCookie();
  }

  get(name, options) {
    return this.universalCookie.get(name, options);
  }

  set(name, value, options) {
    this.universalCookie.set(name, value, options);
  }

  remove(name, options) {
    this.universalCookie.remove(name, options);
  }
}

export const Cookies = new MyCookie();
